export class SetupModel{


  constructor(
    public protocol:string,
    public port:string,
    public host:string,
    public storeID:number
  )
  {

  }
}



// WEBPACK FOOTER //
// ./src/models/LoginModel/SetupModel.ts